import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';

import PDFCheckBoxImg from './PDFCheckBoxImg';

const getTableCellBorder = (val) => (val === true ? '1px solid black' : 'none');

export const PDFRow = ({ children, style = {}, justify = 'start', align = 'top', direction = 'row', ...rest }) => {
  const styles = StyleSheet.create({
    row: {
      alignItems: align,
      display: 'flex',
      flexDirection: direction,
      justifyContent: justify,
      ...style,
    },
  });
  return (
    <View style={styles.row} {...rest}>
      {children}
    </View>
  );
};

export const PDFText = ({ children, style = {}, preventOverlap = false, ...rest }) => {
  const styles = StyleSheet.create({
    text: {
      fontFamily: 'Open Sans',
      fontSize: 10,
      fontWeight: '400',
      wordWrap: 'break-word',
      ...style,
    },
  });

  if (preventOverlap) {
    //NOTE - To fix text overlap if the string does't not have the space to break into next line.
    //NOTE - This issue is still persist in later version(4.0.0) of @react-pdf/renderer
    //TODO - Will cleaned up this below approach once this text overlap issue is fixed in upcoming versions
    //STUB - Kindly use this approach on demand based only
    return (
      <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        {String(children)
          .split('')
          .map((val) => (
            <Text key={val} style={styles.text} {...rest}>
              {val}
            </Text>
          ))}
      </View>
    );
  }
  return (
    <Text style={styles.text} {...rest}>
      {children}
    </Text>
  );
};

export const PDFDarkHeader = ({ children, style = {}, textStyles = {}, isFirst }) => {
  const styles = StyleSheet.create({
    header: {
      backgroundColor: 'black',
      paddingBottom: isFirst ? 1 : 0,
      paddingVertical: isFirst ? 0 : 1,
      width: '100%',
      ...style,
    },
  });
  return (
    <Text style={styles.header}>
      <PDFText style={{ ...{ color: 'white', textAlign: 'center' }, ...textStyles }}>{children}</PDFText>
    </Text>
  );
};

export const PDFTable = ({ children, style = {} }) => {
  const styles = StyleSheet.create({
    text: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      width: '100%',
      ...style,
    },
  });
  return <View style={styles.text}>{children}</View>;
};

export const PDFTableRow = ({ children, style = {}, ...rest }) => {
  const styles = StyleSheet.create({
    text: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      width: '100%',
      ...style,
      // backgroundColor: "blue",
      // alignItems: "stretch",
    },
  });
  return (
    <View style={styles.text} {...rest}>
      {children}
    </View>
  );
};

export const PDFTableCell = ({
  children,
  style = {},
  width = 'auto',
  borderTop = true,
  borderRight = true,
  borderBottom = true,
  borderLeft = true,
  padding = 3,
  justify = 'center',
  ...rest
}) => {
  const styles = StyleSheet.create({
    view: {
      borderBottom: getTableCellBorder(borderBottom),
      borderLeft: getTableCellBorder(borderLeft),
      borderRight: getTableCellBorder(borderRight),
      borderTop: getTableCellBorder(borderTop),
      marginLeft: -1,
      marginTop: -1,
      paddingHorizontal: padding,
      paddingVertical: 0,
      width,
      ...style,
      // backgroundColor: "yellow",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: justify,
    },
  });
  return (
    <View style={styles.view} {...rest}>
      {children}
    </View>
  );
};

export const PDFDivider = ({ style = {} }) => {
  const styles = StyleSheet.create({
    view: {
      borderBottom: '1px solid black',
      width: '100%',
      ...style,
    },
  });
  return <View style={styles.view} />;
};

export const PdfGetTextUnderline = ({ value, fontWeight = '400' }) => {
  return (
    <PDFText
      style={{
        fontWeight,
        textDecoration: value ? 'underline' : 'none',
      }}
    >
      {!value ? '__________________' : value}
    </PDFText>
  );
};

export const PDFCheckBox = ({
  value = false,
  label = 'label',
  size = 10,
  fontSize = 8,
  fontWeight = '700',
  isReverse = false,
  colon = true,
}) => {
  const styles = StyleSheet.create({
    text: {
      fontSize,
      fontWeight,
    },
  });
  return (
    <PDFRow
      direction={isReverse ? 'row-reverse' : 'row'}
      style={{ alignItems: 'center', flexWrap: 'nowrap' }}
      justify={`flex-${isReverse ? 'end' : 'start'}`}
    >
      <PDFText style={styles.text}>{label}</PDFText>
      {colon && <PDFText style={{ ...styles.text, marginLeft: 1, marginRight: 3 }}>:</PDFText>}

      {colon ? '' : <View style={{ width: 5 }} />}

      <View>
        <PDFCheckBoxImg size={size} isChecked={value} />
      </View>
    </PDFRow>
  );
};

export const PDFPage = ({ children, paddingHorizontal = 10, paddingVertical = 20, style = {} }) => {
  const styles = StyleSheet.create({
    page: {
      display: 'flex',
      flexDirection: 'column',
      height: 'auto',
      ontFamily: 'Open Sans',
      paddingHorizontal,
      paddingVertical,
    },
  });

  return (
    <Page size="A4" style={{ ...styles.page, ...style }} orientation="portrait">
      {children}
    </Page>
  );
};

export const pdfStyles = StyleSheet.create({
  border: { border: '1px solid black' },
  borderBottom: {
    borderBottom: '1px solid black',
  },
  borderLeft: {
    borderLeft: '1px solid black',
  },
  borderRight: {
    borderRight: '1px solid black',
  },
  borderTop: {
    borderTop: '1px solid black',
  },
  header: { paddingHorizontal: 10, paddingVertical: 5 },
  headerRow: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  image: {
    width: '60%',
  },
  imageSection: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingVertical: 10,
    width: '100%',
  },
  section: {
    paddingHorizontal: 5,
    paddingVertical: 10,
  },
  tableCol: {
    fontSize: 8,
  },
  tableHeader: {
    fontSize: 8,
    fontWeight: '700',
    textAlign: 'center',
  },
  title: { fontSize: 16, fontWeight: '700' },
});
